import React, { useState, useEffect } from "react";
import { AppBar, Toolbar, Box, Button, Container } from "@mui/material";
import { useNavigate } from "react-router-dom";
import logo from "../../../../../../assets/img/logo.png";

const Header = () => {
  const navigate = useNavigate();
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    const section = document.getElementById(id);
    if (section) {
      section.scrollIntoView({
        behavior: "smooth",
        block: "start"
      });
    }
  };

  const navStyle = {
    color: scrolled ? "#333" : "#111",
    fontWeight: 600,
    textTransform: "none" as const,
    fontSize: "16px",
    px: 2,
    py: 1,
    borderRadius: "8px",
    transition: "all 0.3s ease",
    "&:hover": {
      backgroundColor: "rgba(31, 93, 59, 0.08)",
      color: "#1f5d3b"
    }
  };

  return (
    <AppBar
      position="fixed"
      elevation={scrolled ? 4 : 0}
      sx={{
        background: scrolled ? "rgba(255, 255, 255, 0.95)" : "rgba(255, 255, 255, 0.8)",
        backdropFilter: "blur(12px)",
        transition: "all 0.3s ease",
        borderBottom: scrolled ? "none" : "1px solid rgba(0,0,0,0.05)",
        py: scrolled ? 0.5 : 1
      }}
    >
      <Container maxWidth="lg">
        <Toolbar sx={{ display: "flex", justifyContent: "space-between", px: "0 !important" }}>
          
          <Box
            component="img"
            src={logo}
            sx={{
              height: scrolled ? 50 : 60,
              transition: "height 0.3s ease",
              cursor: "pointer"
            }}
            onClick={() => scrollToSection("home")}
          />

          <Box sx={{ display: { xs: "none", md: "flex" }, alignItems: "center", gap: 1 }}>
            
            <Button onClick={() => scrollToSection("home")} sx={navStyle}>
              Home
            </Button>

            <Button onClick={() => scrollToSection("about")} sx={navStyle}>
              About
            </Button>

            <Button onClick={() => scrollToSection("how-it-works")} sx={navStyle}>
              Services
            </Button>

            <Button onClick={() => scrollToSection("contact")} sx={navStyle}>
              Contact
            </Button>

            <Button
              variant="contained"
              sx={{
                ml: 2,
                backgroundColor: "#1f5d3b",
                color: "#fff",
                fontWeight: 600,
                textTransform: "none",
                borderRadius: "24px",
                px: 4,
                py: 1.2,
                boxShadow: "0 4px 14px 0 rgba(31, 93, 59, 0.39)",
                transition: "all 0.3s ease",
                "&:hover": {
                  backgroundColor: "#16442b",
                  transform: "translateY(-2px)",
                  boxShadow: "0 6px 20px rgba(31, 93, 59, 0.4)"
                }
              }}
              onClick={() => navigate("/account/login")}
            >
              Sign In
            </Button>
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
};

export default Header;